import gql from 'graphql-tag'

export const GET_SUMMARY_FOR_URL = gql`
  subscription GetSummaryForUrl($url: String!) {
    getSummaryForUrl(url: $url)
  }
`
